var React = require('react');

function StepCircle0560px (props) {
    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","d":"M30 58c15.464 0 28-12.536 28-28S45.464 2 30 2 2 14.536 2 30s12.536 28 28 28zm0 2c16.569 0 30-13.431 30-30C60 13.431 46.569 0 30 0 13.431 0 0 13.431 0 30c0 16.569 13.431 30 30 30zm5.832-41.4H25.68l-1.512 10.584c.828-.144 1.944-.252 3.348-.252 4.644 0 6.732 2.556 6.768 5.94.036 3.528-2.664 6.048-6.048 6.048-2.16 0-3.924-.792-4.824-1.404l-.684 1.368c1.008.756 2.988 1.512 5.4 1.512 4.32 0 7.884-3.132 7.884-7.848 0-3.096-1.8-5.184-3.636-6.084-1.368-.684-2.808-1.008-4.356-1.008-1.044 0-1.62.072-2.16.18l1.152-7.524h8.82V18.6z"}));
}

StepCircle0560px.displayName = "StepCircle0560px";

StepCircle0560px.defaultProps = {"viewBox":"0 0 60 60"};

module.exports = StepCircle0560px;

StepCircle0560px.default = StepCircle0560px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/60px/step-circle-05-60px.svg
// module id = 1210
// module chunks = 0